
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import LazyRoute from "./components/LazyRoute";
import Index from "./pages/Index";

// Lazy loaded routes for better performance
const PropertyDetails = lazy(() => import("./pages/PropertyDetails"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Contact = lazy(() => import("./pages/Contact"));
const Reviews = lazy(() => import("./pages/Reviews"));
const Book = lazy(() => import("./pages/Book"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Initialize QueryClient with error handling
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route 
              path="/details" 
              element={
                <LazyRoute>
                  <PropertyDetails />
                </LazyRoute>
              } 
            />
            <Route 
              path="/gallery" 
              element={
                <LazyRoute>
                  <Gallery />
                </LazyRoute>
              } 
            />
            <Route 
              path="/contact" 
              element={
                <LazyRoute>
                  <Contact />
                </LazyRoute>
              } 
            />
            <Route 
              path="/book" 
              element={
                <LazyRoute>
                  <Book />
                </LazyRoute>
              } 
            />
            <Route 
              path="/reviews"
              element={
                <LazyRoute>
                  <Reviews />
                </LazyRoute>
              } 
            />
            <Route 
              path="/thank-you" 
              element={
                <LazyRoute>
                  <ThankYou />
                </LazyRoute>
              } 
            />
            <Route 
              path="*" 
              element={
                <LazyRoute>
                  <NotFound />
                </LazyRoute>
              } 
            />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
